import { isBlankValue } from '../objects/isBlankValue';
import { isEmptyArray } from '../objects/isEmpty';
import { mergeArrays } from './mergeArrays';

/**
 * Add a value to an array if it isn't already there
 *
 * @param array
 * @param value
 * @returns
 */
export function addValue<T>(array: T[], value: T, ignoreBlank = true): T[] {
	// Default to assuming we need to add the value
	let shouldAddValue = true;

	// Value is blank
	if (ignoreBlank && isBlankValue(value)) {
		shouldAddValue = false;
	}
	// Value is already in the array
	else if (array?.includes(value)) {
		shouldAddValue = false;
	}

	if (shouldAddValue) {
		if (isEmptyArray(array)) {
			return [value];
		}
		return mergeArrays([array, value]);
	}

	// Original array was empty
	if (isEmptyArray(array)) {
		return [];
	}

	// If not adding the value, just return a copy of the array
	return [...array];
}

/**
 * Add values to an array if they aren't already there
 *
 * @param array
 * @param values
 * @returns
 */
export function addValues<T>(array: T[], values: T[]): T[] {
	if (isEmptyArray(values)) {
		return [...array];
	}

	return values.reduce((result, value) => addValue(result, value), array);
}
